//
// GENERATED by KVision
//
package pl.finn.forms.fk02

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class Fk02Service : IFk02Service

object Fk02ServiceManager : KVServiceManager<Fk02Service>(Fk02Service::class) {
    init {
        registerKVisionServiceExceptions()
        bind(IFk02Service::nowy, HttpMethod.POST, null)
        bind(IFk02Service::edycja, HttpMethod.POST, null)
        bind(IFk02Service::sprawdz, HttpMethod.POST, null)
        bind(IFk02Service::zapisz, HttpMethod.POST, null)
        bind(IFk02Service::podglad, HttpMethod.POST, null)
    }
}
